import { Loader } from '@opendoor/bricks';
import * as React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import GenericError from '../components/common/GenericError';
import * as resaleClosingDashboardActions from '../store/resaleClosingDashboard/actions';
import * as resaleClosingDashboardSelectors from '../store/resaleClosingDashboard/selectors';

export default function resaleClosingDashboardIndexLoader(ComposedComponent: React.ComponentType) {
  interface IProps {
    // From React Router:
    location: object;
    // Connected Props:
    listingOffersError: string;
    listingOffersIsLoading: boolean;
    maybeFetchListingOffers: () => void;
  }

  class ListingOffersLoader extends React.Component<IProps> {
    public componentDidMount() {
      const { maybeFetchListingOffers } = this.props;
      maybeFetchListingOffers();
    }

    public render() {
      const { listingOffersIsLoading, listingOffersError } = this.props;

      if (!listingOffersIsLoading && !listingOffersError) {
        return <ComposedComponent {...this.props} />;
      }

      return (
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              {listingOffersIsLoading ? <Loader /> : listingOffersError && <GenericError />}
            </div>
          </div>
        </div>
      );
    }
  }

  const mapStateToProps = createSelector(
    [
      resaleClosingDashboardSelectors.listingOffersError,
      resaleClosingDashboardSelectors.listingOffersIsLoading,
    ],
    (listingOffersError: string, listingOffersIsLoading: boolean) => ({
      listingOffersError,
      listingOffersIsLoading,
    }),
  );

  const mapDispatchToProps = (dispatch: any) => {
    return {
      maybeFetchListingOffers: () => {
        dispatch(resaleClosingDashboardActions.maybeFetchListingOffers());
      },
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ListingOffersLoader);
}
